import numeral from 'numeral';
import { lovValue } from '../../form/formUtils';
import { LovItem } from '../../metamodel/mdEntity';



// load a language
numeral.language('cs', {
  delimiters: {
    thousands: ' ',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal : function (num) {
    return '.';
  },
  currency: {
    symbol: 'Kč'
  }
});

// switch between languages
numeral.language('cs');


const DEFAULT_NUMBER_FORMAT = '0[.][00000000]';
export const DEFAULT_CURRENCY_FORMAT = '0,0.00[000000]';

/**
 * If value is number, it is formateed, otherwise is just returned
 * @param value
 * @param format
 * @returns {*}
 */
export function formatNumber(value, format = DEFAULT_NUMBER_FORMAT) {
  let cislo = (value == null || value === '' || isNaN(value)) ? /*null*/ value : numeral(value).format(format);
  return (typeof cislo === 'object') ? ((cislo === null)?null:cislo.toString()) : cislo;
}

/**
 * If value is parseable to number is parsed to number, otherwise is just returned
 * @param value
 * @returns {number}
 */
export function parseNumber(value) {
  if (value == null || value === '') {
    return null;
  } else {
    if (value.replace) value = value.replace(',','.');
    return (isNaN(value) || (value.endsWith && value.endsWith('.')) ) ? value : Number(value);
  }
}

export function toPlainString(value: any): string {
  return (value != null) ? ( (isNegativeZero(value)) ? "-0" : value.toString() ) : value;
}

function isNegativeZero(x) {
  return x === 0 && (1/x < 0);
}

export function formatMonetaryAmount(amount: number, currencyLov: LovItem<string>): string {
  return formatNumber(amount, DEFAULT_CURRENCY_FORMAT) + " " + lovValue(currencyLov);
}

export function roundTo(num: number, precision: number): number {
  const factor = Math.pow(10, precision)
  return Math.round(num * factor) / factor
}



// WEBPACK FOOTER //
// ./src/core/common/utils/numberUtils.ts